<script lang="ts">
import type { QaCard, VocabCard } from '$types/card';
import RichText from './RichText.svelte';

interface Props {
  card: QaCard | VocabCard;
  revealed: boolean;
}

const { card, revealed }: Props = $props();
const isVocab = $derived(card.type === 'vocab');
</script>

{#if isVocab}
  <div class="card-vocab">
    <div class="vocab-term">{card.front}</div>
    <div class="vocab-hint">› vokabel · was bedeutet das?</div>
    {#if revealed}
      <div class="card-back">
        <div class="back-label">↳ definition</div>
        <div class="back-body"><RichText content={card.back} /></div>
      </div>
    {/if}
  </div>
{:else}
  <div class="card-qa">
    <div class="card-text"><RichText content={card.front} /></div>
    {#if revealed}
      <div class="card-back">
        <div class="back-label">↳ antwort</div>
        <div class="back-body"><RichText content={card.back} /></div>
      </div>
    {/if}
  </div>
{/if}

<style>
  .card-text {
    font-family: var(--font-body), 'Inter', system-ui, sans-serif;
    font-size: 22px;
    line-height: 1.35;
    color: var(--ink);
    font-weight: 500;
    letter-spacing: -0.01em;
    text-wrap: pretty;
  }
  @media (min-width: 600px) {
    .card-text { font-size: 26px; }
  }
  .card-vocab { text-align: center; padding: 10px 0; }
  .vocab-term {
    font-family: var(--font-mono);
    font-size: 48px;
    font-weight: 800;
    color: var(--ink);
    letter-spacing: -0.04em;
    line-height: 1;
  }
  @media (min-width: 600px) {
    .vocab-term { font-size: 56px; }
  }
  .vocab-hint {
    margin-top: 8px;
    font-size: 11px;
    color: var(--muted);
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .card-back {
    margin-top: 18px;
    padding: 12px;
    background: var(--paper-2);
    border-left: 4px solid var(--accent);
    position: relative;
  }
  .card-back::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: repeating-linear-gradient(
      -45deg, transparent 0 6px, rgba(232, 81, 28, 0.04) 6px 7px
    );
    pointer-events: none;
  }
  .back-label {
    font-size: 10px;
    letter-spacing: 0.12em;
    color: var(--accent-2);
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 6px;
  }
  .back-body {
    font-family: var(--font-body), 'Inter';
    font-size: 14px;
    line-height: 1.55;
    color: var(--ink-2);
    position: relative;
  }
  .back-body :global(b), .back-body :global(strong) { color: var(--ink); font-weight: 700; }
</style>
